import request from '@/utils/request';

export const getUserInfo = (params: any) =>
  request({
    url: 'User/info',
    method: 'get',
    params
  });

export const login = (data: any) =>
  request({
    url: 'User/auth',
    method: 'post',
    data
  });
// 注册账号
export const regAccount = (data:any) =>
  request({
    url: 'user/account',
    method: 'post',
    data
  });
export const logout = (data:any) =>
  request({
    url: 'User/auth',
    method: 'DELETE',
    data
  });

export const updataUserInfo = (data: any) =>
  request({
    url: 'User/info',
    method: 'put',
    data
  });

export const getUserList = (params: any) =>
  request({
    url: 'User/userList',
    method: 'get',
    params
  });

export const getRoleList = (params: any) =>
  request({
    url: 'User/role',
    method: 'get',
    params
  });

export const addUser = (data: any) =>
  request({
    url: 'User/user',
    method: 'POST',
    data
  });

export const editUser = (data: any) =>
  request({
    url: 'User/user',
    method: 'PUT',
    data
  });

export const deleteUser = (data: any) =>
  request({
    url: 'User/user',
    method: 'DELETE',
    data
  });
export const batchDeleteUsers = (data: any) =>
  request({
    url: 'User/batchDeleteUsers',
    method: 'DELETE',
    data
  });
export const setUserRole = (data: any) =>
  request({
    url: 'User/setUserRole',
    method: 'POST',
    data
  });

export const setUserDept = (data: any) =>
  request({
    url: 'User/setUserDept',
    method: 'POST',
    data
  });
export const getUserLimit = (params: any) =>
  request({
    url: 'User/getUserLimit',
    method: 'GET',
    params
  });
// 删除角色 人员列表
export const getRoleUserList = (params: any) =>
  request({
    url: 'User/getRoleUserList',
    method: 'get',
    params
  });
// 添加角色 人员列表
export const getNoRoleUserList = (params: any) =>
  request({
    url: 'User/getNoRoleUserList',
    method: 'get',
    params
  });
// 删除 角色人员
export const batchDelRoleUser = (data: any) =>
  request({
    url: 'User/batchDelRoleUser',
    method: 'POST',
    data
  });
  //    邀请人 url
export const getInviteUser = (params: any) =>
  request({
    url: 'User/inviteUser',
    method: 'get',
    params
  });
  // 批量邀请部门
export const getBatchInviteUser = (params: any) =>
  request({
    url: 'User/batchInviteUser',
    method: 'get',
    params,
    responseType: 'blob'
  });
// 获取权限列表
export const getRolePersonnelInfo = (params: any) =>
  request({
    url: 'User/getRolePersonnelInfo',
    method: 'get',
    params
  });

// 创建角色
export const createRole = (data: any) =>
  request({
    url: 'User/Role',
    method: 'POST',
    data
  });
// 编辑角色
export const editRole = (data: any) =>
  request({
    url: 'User/Role',
    method: 'PUT',
    data
  });
// 删除角色
export const deleteRole = (data: any) =>
  request({
    url: 'User/Role',
    method: 'DELETE',
    data
  });
  // 上传excel
export const uploadFile = (data: any) =>
  request({
    url: 'User/uploadFile',
    method: 'POST',
    data
  });
// 导入部门

export const importUsers = (data:any) =>
  request({
    url: 'User/importUsers',
    method: 'POST',
    data
  });
  // 修改密码
export const modifyPwd = (data:any) =>
  request({
    url: 'User/password',
    method: 'POST',
    data
  });
// 注销账号
export const delAccount = (data:any) =>
  request({
    url: 'user/account',
    method: 'DELETE',
    data
  });
  // 解绑微信
export const deleteWeixin = (data: any) =>
  request({
    url: 'User/weixin',
    method: 'DELETE',
    data
  });
  // 退出部门
export const quitCompanyDept = (data: any) =>
  request({
    url: 'User/quitCompanyDept',
    method: 'POST',
    data
  });
// 工程师指派获取工程师列表
export const getEngineerList = (params:any) =>
  request({
    url: 'User/getEngineerList',
    method: 'get',
    params
  });
export const getWorkUser = (params:any) =>
  request({
    url: 'User/workUser',
    method: 'get',
    params
  });
  // 授权账户
export const authLogin = (data:any) =>
  request({
    url: 'User/authLogin',
    method: 'POST',
    data
  });
  //  企业微信手动同步
export const syncQywxUser = (data:any) =>
  request({
    url: 'UserSync/syncQywxUser',
    method: 'POST',
    data
  });
  // 导入企业微信手动同步
export const importQywxUser = (data:any) =>
  request({
    url: 'UserSync/importQywxUser',
    method: 'POST',
    data
  });
  // 企业微信记录
export const syncRecordList = (params:any) =>
  request({
    url: 'UserSync/syncRecordList',
    method: 'get',
    params
  });
// 切换公司
export const swishCompany = (data:any) =>
  request({
    url: 'User/company',
    method: 'PUT',
    data
  });
export const changeAdmin = (data: any) =>
  request({
    url: 'User/changeAdmin',
    method: 'PUT',
    data
  });

export const authUserList = (params: any) =>
  request({
    url: 'User/authUserList',
    method: 'get',
    params
  });
  // User/quicklyCreateRole
export const quicklyCreateRole = (data:any) =>
  request({
    url: 'User/quicklyCreateRole',
    method: 'POST',
    data
  });
  // 获取有处理订单权限的人
export const getDealOrderUser = (params: any) =>
  request({
    url: 'User/dealOrderUser',
    method: 'get',
    params
  });

export const getUserSettings = (params: any) =>
  request({
    url: 'User/settings',
    method: 'get',
    params
  });

export const setUserSettings = (data: any) =>
  request({
    url: 'User/settings',
    method: 'PUT',
    data
  });
export const getStateList = (params: any) =>
  request({
    url: 'User/stateList',
    method: 'get',
    params
  });
export const setUserState = (data: any) =>
  request({
    url: 'User/setState',
    method: 'PUT',
    data
  });
